import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  ViewChild
}                                                    from '@angular/core';
import {TRANSLATE_EDIT_FORM}                         from '../../ap-animation/translate-panel-text.animation';
import {
  ApEditActionComponent
}                                                    from '../../entry-components/ap-docu-entry-components/ap-edit-action.component';
import {MapViewMode}                                 from '../../ap-interface';
import {DomSanitizer}                                from '@angular/platform-browser';
import {get}                                         from 'lodash';
import {ApDocuUtils}                                 from '../utils/ap-docu-utils';
import {GetRoundNumericPipe}                       from '../../ap-utils';
import {ApDynGridPropertyColumnConfig, FilterType} from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {ApDynGridStatusColumnConfig}               from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  ApDynGridPagerWizardBreadcrumbsStepper,
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardExport,
  ApDynGridPagerWizardSection
}                                                    from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {ApDynGridColumnConfigBase}                   from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {BehaviorSubject, Observable, Subscription}   from 'rxjs';
import {ApDynGridEditColumnConfig}                   from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {RowArgs, SelectableSettings, SelectionEvent} from '@progress/kendo-angular-grid';
import {ApDynComponentComponent}                     from '../../ap-dyncomponent/ap-dyncomponent.component';
import {ApDynGridButtonColumnConfig}                 from '../../ap-dyngrids/config/ap-dyn-grid-button-column-config';
import {APP_CONFIGURATION}                           from '../../ap-core/config';
import {ApShowTrackOnMapService}                     from '../../ap-utils/service/ap-show-track-on-map.service';
import {CropTypeStore}                               from '../../stores/base-data/crop.types.store';
import {SettingsStore}                               from '../../stores/base-data/settings.store';
import {FieldStore}                                  from '../../stores/farm/field.store';
import {FormStore}                                   from '../../stores/layout/form.store';
import {MapViewStore}                                from '../../stores/layout/mapview.store';
import {ActionStore}                                 from '../../stores/docu/action.store';
import {FleetActionAttachmentStore}                  from '../../stores/docu/fleet.action.attachment.store';
import {SliceStore}                                  from '../../stores/docu/slice.store';
import {TranslationStore}                            from '../../stores/translation/translation.store';
import {MapStore}                                    from '../../stores/map/map.store';
import {LanguageStore}                               from '../../stores/translation/language.store';
import {ApDateService}                               from '../../ap-core/services/ap-date-service';
import IField = Data.FieldManagement.IField;
import IFleetAction = Data.DocuContext.FleetManagement.IFleetAction;
import ICropTypes = Data.BaseData.ICropTypes;
import ISettings = Data.BaseData.ISettings;

/**
 * Component for the fleetmanagement-overview
 */
@Component({
  selector: 'ap-fleetmanagement-overview',
  animations: [TRANSLATE_EDIT_FORM],
  changeDetection: ChangeDetectionStrategy.Default,
  template: `
    <ap-dyncomponent [caption]="caption"
                     [canSearch]="true"
                     [headerIcon]="'ap-icon-field-works'"
                     [filterTooltip]="'filterTooltip'"
                     [headerSvg]=""
                     [columns]="columns"
                     [items]="items"
                     [loading$]="loading$"
                     [pager]="pager"
                     [rowSelected]="gridRowSelected"
                     [selectable]="selectable"
                     (edit)="onEdit($event)"
                     (selectionChange)="selectionChange($event)">
    </ap-dyncomponent>`,
})

export class ApFleetmanagementOverviewComponent implements OnInit, AfterContentInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) dynComponent: ApDynComponentComponent;
  caption = 'Global__Procedures';
  columns: ApDynGridColumnConfigBase[] = [];
  loading$: Observable<boolean>;
  items: any[] = [];
  pager: ApDynGridPagerWizardConfig;
  svg;
  selectable: SelectableSettings;

  private _cropTypes: ICropTypes[] = [];
  private _fleetActions: any[] = [];
  private _mapViewMode: MapViewMode;
  private _onBack = new EventEmitter();
  private _onNext = new EventEmitter();
  private _onSelect = new BehaviorSubject<boolean>(false);
  private _selectedAction: IFleetAction;
  private _settings: ISettings;
  private _showField = new EventEmitter<any>();
  private _showLine = new EventEmitter<any>();
  private _subscriptions: Subscription[] = [];

  private _main = true;

  constructor(private fleetActionAttachmentStore: FleetActionAttachmentStore,
              private actionStore: ActionStore,
              private cropTypeStore: CropTypeStore,
              private fieldStore: FieldStore,
              private formStore: FormStore,
              private mapViewStore: MapViewStore,
              private roundNumericPipe: GetRoundNumericPipe,
              private translationStore: TranslationStore,
              private mapStore: MapStore,
              private sliceStore: SliceStore,
              private settingsStore: SettingsStore,
              private domSanitizer: DomSanitizer,
              private dateService: ApDateService,
              private showTrackOnMapService: ApShowTrackOnMapService,
              private languageStore: LanguageStore) {
    this.mapViewStore.hideMapView();
    this._subscriptions.push(this._onBack.subscribe(() => this._onBackClick()));
    this._subscriptions.push(this._onNext.subscribe(() => this._onNextClick()));
    this._subscriptions.push(this._showField.subscribe((item) => this._showFieldClick(item)));
    this._subscriptions.push(this._showLine.subscribe((item) => this._showLineClick(item)));
  }

  gridRowSelected = (e: RowArgs) => this._isSelected(e.dataItem);

  /**
   * when the component is loaded
   */
  ngOnInit(): void {
  }

  ngAfterContentInit(): void {
    this.getDataFromStore();
    this.gridBuilderMain();
  }

  /**
   * cleanup subscriptions
   */
  ngOnDestroy(): void {
    this._subscriptions.forEach(d => {
      d.unsubscribe();
    });
    this.showTrackOnMapService.clear();
  }

  gridBuilderMain(): void {
    this.languageStore.SelectedLanguage$.subscribe(l => {
      this._main = true;
      this.columns = [
        new ApDynGridStatusColumnConfig({
          field: 'SourceItem.Status', class: 'StatusClass', description: 'StatusDesc',
          showHeaderTitle: true, filterable: true, sortIndex: 1
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Field.FieldNumber', title: 'Global__Number', width: 80,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Field.FieldSubnumber', title: 'Global__FieldPartShort', width: 80,
          filterable: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Field.FieldName', title: 'Global__FieldName', width: 120, headerFilterable: true,
          cssClass: 'left',
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Area', title: 'Global__Unit_ha', width: 65,
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.CropName', title: 'Global__CropType', width: 100,
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'LastActionDate', title: 'Docu_Last_Action', width: 120, sortIndex: 0, sortDesc: true,
          format: `${l.DateFormat} ${l.TimeFormat}`, headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.AttachmentCount', title: 'Global__Saved_Procedures', width: 100,
        }),
        new ApDynGridButtonColumnConfig(
          {callback: this._showField, imageUrl: APP_CONFIGURATION.ButtonZoomToMapImage}),
      ];

      this.selectable = {checkboxOnly: false, mode: 'single'};

      this.pager = new ApDynGridPagerWizardConfig(
        new ApDynGridPagerWizardSection(),
        new ApDynGridPagerWizardBreadcrumbsStepper(
          ['Nutrients__SelectFieldsTitle', 'Global__FieldFilter'], 0),
        new ApDynGridPagerWizardButton('Global_Next_With_Arrow', this._onNext, {active: this._onSelect})
      );
    });
  }

  gridBuilderDetails(): void {
    this.languageStore.SelectedLanguage$.subscribe(l => {
      this._main = false;
      this.columns = [
        new ApDynGridStatusColumnConfig({
          field: 'SourceItem.Status', class: 'StatusClass', description: 'StatusDescription',
          showHeaderTitle: true, filterable: true, sortIndex: 2
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'FromDate', title: 'Docu_Ini__Date', width: 90, sortIndex: 0, sortDesc: true,
          format: l.DateFormat
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'FromTime', title: 'Docu_Data__Start', width: 80, sortIndex: 1, sortDesc: true,
          format: l.TimeFormat
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Duration', title: 'Docu_Ini__Duration', width: 80,
          format: 'HH:mm:ss'
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'TimeOfNoUse', title: 'Docu_Ini__TimeOfNonuse', width: 80, format: 'HH:mm:ss'
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Area', title: 'Global__Area', width: 65,
          tooltip: (dataItem) => dataItem['Area'],
          pipes: [{pipe: this.roundNumericPipe, args: [this._settings.DigitsAfterDecimalPoint]}]
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Attachment.Machine.Name', title: 'Base__Engine', headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Attachment.Machine.Sign', title: 'Docu_Ini__NumberPlate', headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Attachment.Instrument.Name', title: 'Docu_Ini__Tool', hide: true, headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'SourceItem.Attachment.WorkType.Description',
          title: 'Docu_Ini__WorkType',
          hide: true,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'DriverName', title: 'Docu_Ini__Motorist', hide: true, headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Application0', title: 'Docu_Ini__Medium', hide: true, headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Application1', title: 'Docu_Ini__Medium', hide: true, headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          field: 'Application2', title: 'Docu_Ini__Medium', hide: true, headerFilterable: true
        }),
        new ApDynGridButtonColumnConfig(
          {
            callback: this._showLine, imageUrl: APP_CONFIGURATION.ButtonZoomToMapImage,
            itemBusy$: this.showTrackOnMapService.getPendingSubject.bind(this.showTrackOnMapService)
          }),
        new ApDynGridEditColumnConfig({})
      ];

      this.selectable = {checkboxOnly: true, mode: 'multiple'};

      this.pager = new ApDynGridPagerWizardConfig(
        new ApDynGridPagerWizardButton('Global_Back_With_Arrow', this._onBack),
        new ApDynGridPagerWizardBreadcrumbsStepper(
          ['Nutrients__SelectFieldsTitle', 'Global__FieldFilter'], 1),
        new ApDynGridPagerWizardExport()
      );
    });
  }

  /**
   * retrieves all data from the store
   */
  getDataFromStore(): void {
    this.loading$ = this.fleetActionAttachmentStore.Listen(s => s.loading);
    this._subscriptions.push(this.settingsStore.FirstSetting$.subscribe(s => this._settings = s));

    this._subscriptions.push(this.mapViewStore.Listen(s => s.mode).subscribe(
      mapViewMode => this._mapViewMode = mapViewMode
    ));

    this._subscriptions.push(this.actionStore.Listen(s => s.fleetActions).subscribe(actions => {
      if (actions === null) {
        return;
      }
      this._fleetActions = actions.map((a: IFleetAction) => {
        const field = this.fieldStore.getFieldById(a.Id);
        const geom = this.fieldStore.getCurrentFieldGeom(field);
        return {
          Id: a.Id,
          Field: field,
          SourceItem: a,
          StatusDesc: this.translationStore.FindTranslationForSelectedLanguage(
            a.Status === -1 ? 'Docu_Invalid' : a.Status === 1 ? 'Docu_Is_Modified' : 'Docu_Not_Modified'),
          StatusClass: a.Status === -1 ? 'ap-status-red' : a.Status === 1 ? 'ap-status-green' : 'ap-status-yellow',
          CropName: this._getCropName(a),
          LastActionDate: this.dateService.toFarmDateFromUtcGetJsDate(a.LastAction),
          Area: geom &&
          geom.AdminArea > 0 ?
            this.roundNumericPipe.transform(
              geom.AdminArea / 10000,
              this._settings.DigitsAfterDecimalPoint) : null
        };
      });
      if (this._main) {
        this.items = this._fleetActions;
      }
    }));

    this._subscriptions.push(this.fleetActionAttachmentStore.Listen(s => s.data).subscribe(details => {
      if (details === null) {
        return;
      }
      if (this._main) {
        return;
      }
      this.items = details.map(a => {
        const date = new Date(a.Attachment.From);
        return {
          Id: a.Id,
          SourceItem: a,
          StatusDesc: this.translationStore.FindTranslationForSelectedLanguage(
            a.Status === -1 ? 'Docu_Invalid' : a.Status === 1 ? 'Docu_Is_Modified' : 'Docu_Not_Modified'),
          StatusClass: a.Status === -1 ? 'ap-status-red' : a.Status === 1 ? 'ap-status-green' : 'ap-status-yellow',
          Duration: ApDocuUtils.getDurationOfSlices(a.Slices).toDate(),
          TimeOfNoUse: ApDocuUtils.getStandStillTimeOfSlices(a.Slices).toDate(),
          Area: a.Slices.map(s => s.NettoArea).reduce((acc, val) => acc + val),
          FromDate: date,
          FromTime: date,
          DriverName: a.Attachment.Driver?.FullName ?? '',
          Application0: a.Attachment.Application && a.Attachment.Application[0] ? a.Attachment.Application[0].Key : '-',
          Application1: a.Attachment.Application && a.Attachment.Application[1] ? a.Attachment.Application[1].Key : '-',
          Application2: a.Attachment.Application && a.Attachment.Application[2] ? a.Attachment.Application[2].Key : '-'
        };
      });
    }));

    this._subscriptions.push(this.cropTypeStore.Listen(s => s.data).subscribe(cropType => {
      if (cropType == null) {
        return;
      }
      this._cropTypes = cropType.filter(c => c.Selected);
    }));
  }

  /**
   * editHandler
   */
  editHandler(dataItem): void {
    this.onEdit(dataItem);
  }

  /**
   * on edit event
   */
  onEdit($event: any): void {
    if (this._mapViewMode !== MapViewMode.NORMAL) {
      this.mapViewStore.showMapView();
    }
    setTimeout(() => this.formStore.openForm({component: ApEditActionComponent, data: $event.SourceItem}), 200);
  }

  selectionChange(event: SelectionEvent): void {
    if (this._main) {
      if (event.selectedRows.length === 0) {
        this._selectedAction = undefined;
        this._onSelect.next(false);
        this.fieldStore.changeSelectedField([]);
      } else {
        this._selectedAction = get(event.selectedRows[0].dataItem, 'SourceItem');
        this.fieldStore.changeSelectedField([this._selectedAction.Id.toString()]);
        this._onSelect.next(true);
      }
    } else {
      const rows = event.selectedRows.concat(event.deselectedRows);
      rows.forEach(row => {
        this._showLineClick(row.dataItem);
      });
    }
  }

  /**
   * get the title tex
   */
  private _getTitle(item: IField): string {
    return this.translationStore.FindTranslationForSelectedLanguage('Global__Details') + ': ' + item.FieldName;
  }

  /**
   * on next button click event
   */
  private _onNextClick(): void {
    this.mapViewStore.hideMapView();
    this.gridBuilderDetails();
    const field = this.fieldStore.getFieldById(this._selectedAction.Id);
    this.fieldStore.changeSelectedField([field.Id.toString()]);
    this.fleetActionAttachmentStore.loadFleetActionAttachments(field.Id);
    if (field.FieldGeoms.length > 0) {
      this.svg = field.FieldGeoms;
    }
    this.caption = this._getTitle(field);
    this.gridRowSelected = (e: RowArgs) => this._isActive(e.dataItem);
  }

  /**
   * on back button click event
   */
  private _onBackClick(): void {
    this.gridBuilderMain();
    this.items = this._fleetActions;
    this.mapViewStore.hideMapView();
    this.fieldStore.changeSelectedField(['']);
    this.caption = 'Global__Procedures';
    this.svg = undefined;
    this.showTrackOnMapService.clear();
    this.gridRowSelected = (e: RowArgs) => this._isSelected(e.dataItem);
  }

  private _getCropName(dataItem: IFleetAction): string {
    const field = this.fieldStore.getFieldById(dataItem.Id);
    if (field.FieldCrops !== null && field.FieldCrops.length) {
      const cropType = this._cropTypes.find(c => c.CropKey === field.FieldCrops[0].Cropkey);
      if (cropType) {
        return cropType.Description;
      }
    }
    return '-';
  }

  private _showFieldClick(event): void {
    this.mapViewStore.showMapView();
    const sourceItem: IFleetAction = event['SourceItem'];
    this.fieldStore.changeSelectedField([sourceItem.Id.toString()]);
  }

  private _showLineClick(event): void {
    const dataItem = event['SourceItem'];
    this.showTrackOnMapService.generateGeoJsonByField(
      dataItem.Attachment, this.fieldStore.getFieldById(dataItem.Slices[0].FieldIdOnEnd), dataItem.Attachment.From);
  }

  private _isSelected(dataItem: any): boolean {
    return this._selectedAction && this._selectedAction.Id === dataItem.Id;
  }

  private _isActive(dataItem: any): boolean {
    return this.showTrackOnMapService.isActive(dataItem.Id);
  }
}
